import React, { useState, useEffect } from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar.js";

import { connect } from "react-redux";
import { gain_user } from "../../../store/acion";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import { async } from "@firebase/util";
import { useLocation, useNavigate } from "react-router-dom";
import {
  doc,
  setDoc,
  collection,
  getFirestore,
  updateDoc,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { deepPurple } from "@mui/material/colors";

function Profile(props) {
  const navigate = useNavigate();

  let [name, setName] = useState();
  let [address, setAddress] = useState("Local addredd");
  let [image, setImage] = useState(
    localStorage.getItem("user_profile") == "undefined" ||
      localStorage.getItem("user_profile") == undefined
      ? "http://i.pravatar.cc/500?img=7"
      : localStorage.getItem("user_profile")
  );
  let [progress, setProgress] = useState("");
  let [error, setError] = useState("");
  let [nameValidate, setnameValidate] = useState("");
  let [emailValidate, setemailValidate] = useState("");
  let [file, setFile] = useState("");
  const [image3, setimage3] = useState("");

  let HideMeShowEdit = () => {
    document.getElementById("SeeME").style.display = "none";

    document.getElementById("EditME").style.display = "block";

    document.getElementById("hidingMeThis").style.display = "block";
  };

  let HideMeShowEdit1 = () => {
    document.getElementById("SeeME").style.display = "block";

    document.getElementById("EditME").style.display = "none";

    document.getElementById("hidingMeThis").style.display = "none";
  };

  let UpdateME = async () => {
    if (name == "") {
      setnameValidate("* Required");
      return;
    }

    HideMeShowEdit1();

    if (typeof image3 === "object") {
      const storage = getStorage();
      // alert("yes");
      document.getElementById("imageResponsiveinput").style.opacity = 0.5;
      var key = Math.round(Math.random() * 33453452490);

      const uploadTask = uploadBytesResumable(
        ref(storage, `user dp/${image3.name}${key}`),
        image3
      );

      // var ref= firebase.storage().ref(`/`).child(`Dp/${file.name}+${key}`).put(file)
      uploadTask.on(
        "state_changed",
        function (snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //  localStorage.setItem('progress',progress)
          Math.round(progress);

          setProgress(Math.round(progress) + "%");

          switch (snapshot.state) {
            case "paused": // or 'paused'
              break;
            case "running": // or 'running'
              //  ('Upload is running');
              break;
          }
        },
        function (error) {
          // Handle unsuccessful uploads
          //  console.log(error);
        },
        () => {
          if (name) {
            getDownloadURL(uploadTask.snapshot.ref).then(async (pic) => {
              const db = getFirestore();
              await updateDoc(doc(db, "users", request_data.uid), {
                name,
                pic,
              });

              setTimeout(() => {
                document.getElementById(
                  "imageResponsiveinput"
                ).style.opacity = 1;
              }, 500);
            });
          } else {
            getDownloadURL(uploadTask.snapshot.ref).then(async (pic) => {
              const db = getFirestore();
              await updateDoc(doc(db, "users", request_data.uid), {
                pic,
              });

              setTimeout(() => {
                document.getElementById(
                  "imageResponsiveinput"
                ).style.opacity = 1;
              }, 500);
            });
          }
        }
      );
    } else {
      const db = getFirestore();
      await updateDoc(doc(db, "users", request_data.uid), {
        name,
      });
    }

    document.getElementById("SeeME").style.display = "block";

    document.getElementById("EditME").style.display = "none";
    document.getElementById("hidingMeThis").style.display = "none";
  };

  // var openFile = function (event) {
  //   var input = event.target;
  //   var reader = new FileReader();
  //   reader.onload = fileLoaded;
  //   reader.readAsDataURL(input.files[0]);
  // };

  // var fileLoaded = function (event) {
  //   var dataURL = event.target.result;
  //   var output = document.getElementById("output");
  //   output.src = dataURL;

  //   // Do your other stuff here with dataURL
  //   console.log(">>>>>>>>>", dataURL);
  // };

  const [data_gain, setdata_gain] = useState(false);
  const [request_data, setrequest_data] = useState();

  useEffect(() => {
    // if (props.request!='fail') {
    //   console.log("sdsadas",props.request);
    //   let arr=  props.request.filter((e)=>(e.user_uid==localStorage.getItem('user_uid')))
    //   setrequest_data(props.request)
    // }
  }, [data_gain]);

  const re_load = async () => {
    if (props.user == "fail") {
      setdata_gain(false);
      await props.gain_user();
      console.log("fail>>>>>.");
    } else {
      // console.log("yes>>>>>.", props.user);

      let asd = await props.user;
      await setrequest_data(
        await asd.find((e) => e.uid == localStorage.getItem("user_uid"))
      );

      setdata_gain(true);
    }
  };

  useEffect(() => {
    re_load();
  });

  let ChangeMyBack = (file) => {
    // console.log("FILE",file);

    let url = URL.createObjectURL(file);

    // console.log("URL>>>>>",url);
    document.getElementById("imageResponsiveinput").src = url;
    setimage3(file);
  };

  return localStorage.getItem("user_uid") !== null ? (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        {/* <Navbar /> */}
        {/* Header */}
        <div className="relative bg-pink-600 md:pt-12 pb-10">
          <div className="px-4 md:px-10 mx-auto w-full ml-2 d-flex align-items-center justify-content-center flex-column">
           <div style={{height:38}}>

           </div>
            <div className="d-flex align-items-center flex-column pb-9">
              <h1 className="text-white font-semibold text-3xl	 text-center">
               Profile
              </h1>
            </div>
          </div>
        </div>
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <div className="flex flex-wrap"></div>

          <div>
            <div class="loading" id="loading" style={{ display: "none" }}>
              Loading&#8230;
            </div>

            {console.log("awais>>>>>>", request_data)}

            <div className="content">
              <div className="main-body">
                <nav aria-label="breadcrumb" className="main-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="index.html">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      User Profile
                    </li>
                  </ol>
                </nav>
                {data_gain ? (
                  <div className="row gutters-sm">
                    <div className="col-md-4 mb-3">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex flex-column align-items-center text-center">
                            <div class="container1">
                              <div class="avatar-upload">
                                <div class="avatar-edit">
                                  <input
                                    onChange={(e) =>
                                      ChangeMyBack(e.target.files[0])
                                    }
                                    type="file"
                                    id="imageUpload"
                                    accept=".png, .jpg, .jpeg"
                                  />
                                  <label
                                    id="hidingMeThis"
                                    style={{ display: "none" }}
                                    for="imageUpload"
                                  ></label>
                                </div>
                                <div class="avatar-preview">
                                  <img
                                    style={{
                                      width: 140,
                                      height: 140,
                                      borderRadius: 70,
                                    }}
                                    id="imageResponsiveinput"
                                    src={request_data.pic}
                                  ></img>
                                  <div
                                    style={{ marginTop: 10, fontWeight: "550" }}
                                  >
                                    {progress}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-8">
                      <div className="card mb-3" id="SeeME">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Name</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              {request_data.name}{" "}
                            </div>
                          </div>
                          <hr />
                          <br></br>
                          <br></br>

                          <div className="row">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Email</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              {request_data.email}
                            </div>
                          </div>
                          <hr />
                          <div style={{ color: "red" }}>{error}</div>
                          <br></br>

                          <div className="row">
                            <div className="col-sm-12">
                              <button
                                class="btn"
                                style={{
                                  backgroundColor: "#643FFE",
                                  outline: "none",
                                  color: "#fff",
                                }}
                                onClick={() => {
                                  HideMeShowEdit();
                                }}
                              >
                                Edit Profile
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="card"
                        id="EditME"
                        style={{ display: "none" }}
                      >
                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Name</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={request_data.name}
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: 11,
                                  marginTop: 5,
                                }}
                              >
                                {nameValidate}
                              </p>
                            </div>
                          </div>

                          <div className="row mb-3">
                            <div className="col-sm-3">
                              <h6 className="mb-0">Email</h6>
                            </div>
                            <div className="col-sm-9 text-secondary">
                              <input
                                type="text"
                                className="form-control"
                                defaultValue={request_data.email}
                                disabled
                              />
                              <p
                                style={{
                                  color: "red",
                                  fontSize: 11,
                                  marginTop: 5,
                                }}
                              >
                                {emailValidate}
                              </p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-3"></div>
                            <div
                              className="col-sm-9 text-secondary"
                              onClick={() => {
                                UpdateME();
                              }}
                            >
                              {/* <input type="button" class="btn btn-danger" value="Save Changes" /> */}
                              <button
                                class="btn"
                                style={{
                                  backgroundColor: "#643FFE",
                                  outline: "none",
                                  color: "#fff",
                                }}
                                onClick={() => {
                                  UpdateME();
                                }}
                              >
                                Save Changes
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="loading" id="loading" style={{ display: "none" }}>
                    Loading&#8230;
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    navigate("/Login")
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    gain_user: () => dispatch(gain_user()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
